<template>
  <div
    :id="`${config.id || ''}`"
    :class="`magic-ui-page magic-layout-${config.layout}${
      config.className ? ` ${config.className}` : ''
    }`"
    :style="style"
  >
    <slot></slot>
    <magic-ui-component v-for="item in config.items" :key="item.id" :config="item"></magic-ui-component>
  </div>
</template>

<script lang="ts" setup>
import { computed, reactive, onMounted } from 'vue';

import type { MPage } from '@tmagic/schema';
import magicUiComponent from '../../../Component.vue';
import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';

import initValue from '../initValue';

const props = defineProps<{
  config: MPage & typeof initValue;
}>();

const app = useApp(props);
const node = app?.page?.getNode(props.config.id);
app?.emit('created', node);
onMounted(() => {
  app?.emit('mounted', node);
});
const style =  computed(() => app?.transformStyle(props.config.style || {}));

const refresh =  () => {
  window.location.reload();
}

const { visible, show, hide } = useDisplay(props);
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  show,
  hide,
  refresh
});

defineExpose(exportInterface);
</script>
